import React from 'react'

const TablaListaDeSeleccionDeMedicoDQ = ({item}) => {
  return (
    <tr className="border-b" >
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MMCODM}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MMNomM}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MMCedM}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MENomE}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MECodE}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MMRegM}
        </td>
    </tr>
  )
}

export default TablaListaDeSeleccionDeMedicoDQ